module.exports = __webpack_public_path__ + "static/media/hero_img_small.f2204bc6.png";